import { Topbar } from '../layout/Topbar';

export function PageHeader({
  title,
  subtitle,
  actions,
}: {
  title: string;
  subtitle?: React.ReactNode;
  actions?: React.ReactNode;
}) {
  return (
    <Topbar
      breadcrumb={
        <div className="flex items-center gap-3">
          <span className="font-semibold text-text">{title}</span>
          {subtitle && <span className="text-text-faint">{subtitle}</span>}
          {actions && <div className="ml-auto flex items-center gap-2">{actions}</div>}
        </div>
      }
    />
  );
}
